const excelExportTypes = {
  SIMPLE: 'SIMPLE',
  UPLOAD_PREPARED: 'UPLOAD_PREPARED',
};

export { excelExportTypes };
